import { PropsWithChildren, useState } from "react";
import { usePermission } from "@/hooks";
import { ModelType } from "@/types";
import { ModelDialog } from "./model-dialog";
import { FormTypeModelCreate } from "./form-type-model-create";
import { FormTypeModelUpdate } from "./form-type-model-update";

type FormTypeModelsProps = PropsWithChildren & {
  typeModel?: ModelType;
  disable?: boolean;
  onCreated?: (type: ModelType) => void;
};

export function FormTypeModels({ children, typeModel, disable, onCreated }: FormTypeModelsProps) {
  const [open, setOpen] = useState(false);
  const { checkPermission } = usePermission();
  if (disable || !checkPermission("modelstypes", typeModel ? "edit modelstypes" : "create modelstypes")) return null;
  return <ModelDialog title={typeModel ? "Editar tipo de modelo" : "Novo tipo de modelo"}
    description="Organize os modelos por finalidade e escolha a quem se destinam."
    trigger={children} open={open} onOpenChange={setOpen}>
    {typeModel
      ? <FormTypeModelUpdate typeModel={typeModel} handleClose={() => setOpen(false)} />
      : <FormTypeModelCreate handleClose={() => setOpen(false)} onCreated={onCreated} />}
  </ModelDialog>;
}
